export enum Ticker {
  TON = "TON",
  RAFF = "RAFF",
  USDT = "USDT",
}
